import { render, staticRenderFns } from "./newZinvoice.vue?vue&type=template&id=5d7a3934&scoped=true"
import script from "./newZinvoice.vue?vue&type=script&lang=js"
export * from "./newZinvoice.vue?vue&type=script&lang=js"
import style0 from "./newZinvoice.vue?vue&type=style&index=0&id=5d7a3934&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a3934",
  null
  
)

export default component.exports